import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import { Menu } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import ROUTE_URLS from "@/constants/route-urls";
import useAuth from "@/contexts/auth-context";
import useLanguage from "@/contexts/language-context";
import { SidebarMessages } from "@/messages/layout/sidebar";
import NotificationItem from "@/mui/Items/NotificationItem";

interface UserPopoverProps {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: SidebarMessages;
}

export function UserPopover({ isOpen, anchorEl, onClose, messages }: UserPopoverProps) {
  const { logout, user } = useAuth();
  const router = useNavigate();
  const { lang } = useLanguage();

  const { myAccount, goOut } = messages;

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      sx={{ mt: 2 }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <NotificationItem icon={<AccountCircleIcon />}>
        <MDBox display="flex" flexDirection="column">
          <MDTypography variant="button" fontWeight="regular" sx={{ ml: 1 }}>
            {user?.name}
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" sx={{ ml: 1 }}>
            {user?.email}
          </MDTypography>
        </MDBox>
      </NotificationItem>

      <NotificationItem
        onClick={() => router(ROUTE_URLS.profile(lang))}
        icon={<PersonIcon />}
        title={myAccount}
      />

      <NotificationItem onClick={() => logout()} icon={<LogoutIcon />} title={goOut} />
    </Menu>
  );
}
